import React from "react";
import * as S from "./ChatbotPopUpInfo.style";
import { useTranslation } from "react-i18next";
import FlorenzButton from "../../../../florenzComponents/florenzButton/FlorenzButton";

const generalInfoMonaco = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/general-info-monaco.svg`;
const specificGuidesMonaco = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/specific-guides-monaco.svg`;
const imageAnalysisMonaco = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/image-analysis-monaco.svg`;
const algorithmsMonaco = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/algorithms-monaco.svg`;
const talkingHead = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/talking-head.svg`;
const patientLogo = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/patient-logo.svg`;

function ChatbotPopUpInfo({
  florenceView,
  setActivePopUpInfo
}) {
  const {t} = useTranslation("global");

  const infoView = [
    {
      id: 1,
      title: t("chatbotAI.general.title"),
      img: generalInfoMonaco,
      description: t("chatbotAI.general.longDescription")
    },
    {
      id: 2,
      title: t("chatbotAI.patients.title"),
      img: patientLogo,
      description: t("chatbotAI.patients.longDescription")
    },
    {
      id: 4,
      title: t("chatbotAI.guidelines.title"),
      img: specificGuidesMonaco,
      description: t("chatbotAI.guidelines.longDescription")
    },
    {
      id: 8,
      title: t("chatbotAI.imageReading.title"),
      img: imageAnalysisMonaco,
      description: t("chatbotAI.imageReading.longDescription")
    },
    {
      id: 5,
      title: t("globally.monacoAlgorithms"),
      img: algorithmsMonaco,
      description: t("chatbotAI.algorithms.longDescription")
    },
    {
      id: 6,
      title: t("chatbotAI.medicalTransductor.title"),
      img: talkingHead,
      description: t("chatbotAI.medicalTransductor.longDescription")
    }
  ]

  const view = florenceView ? infoView.find(info => info.id === florenceView) : null;

  return (
    <S.ChatbotPopUpInfo>
      <div className="header">
        <FlorenzButton
          size={"s"}
          text={t("globally.close")}
          onClick={() => setActivePopUpInfo(false)}
        />
      </div>
      <div className="info">
        <div className="info__principal">
          <div className="info__titles">
            <div className="title">
              {
                view?.title
              }
            </div>
            <div className="subtitle">
              {
                t("chatbotAI.aboutThisMode")
              }
            </div>
          </div>
          <img className="info__img"
            src={
              view?.img
            }
            alt="info image"
          ></img>
        </div>
        <div className="info__secondary">
          {
            view?.description
          }
        </div>
      </div>
    </S.ChatbotPopUpInfo>
  );
}

export default ChatbotPopUpInfo;
